import React from 'react';

import type { Nullable } from '@clearverify/types';

import type { PeoStaffListQueryVariables, PeoStaffWhere } from 'src/api';
import { useFilterStorage, useSearchQueryVariables } from 'src/hooks/common';
import { preparePeoStaffFilter } from 'src/utils/peoStaff';
import { getUserFullNameFilter } from 'src/utils/user';

export const usePeoStaffListQueryVariables = (peoId?: Nullable<string>) => {
  const searchQueryVariables = useSearchQueryVariables(prepareSearchStaffsFilter);
  const { sortQueryVariable, filter, paginationQueryVariables } = useFilterStorage();

  const filterQueryVariables = React.useMemo(() => preparePeoStaffFilter(filter), [filter]);

  const queryFilter = React.useMemo((): PeoStaffWhere => {
    return {
      peoId: { equals: peoId },
      ...filterQueryVariables,
      ...searchQueryVariables,
    };
  }, [filterQueryVariables, peoId, searchQueryVariables]);

  const variables = React.useMemo((): PeoStaffListQueryVariables => {
    return {
      filter: queryFilter,
      orderBy: sortQueryVariable,
      ...paginationQueryVariables,
    };
  }, [paginationQueryVariables, queryFilter, sortQueryVariable]);

  return variables;
};

const prepareSearchStaffsFilter = (searchValue: Nullable<string>): PeoStaffWhere => {
  return searchValue && searchValue.length > 0
    ? {
        user: getUserFullNameFilter(searchValue),
      }
    : {};
};
